import React, { ReactNode, useEffect } from 'react';
import NavigationHelper from '@components/agile/utils/URLParametersUtils';
import { useLocation } from 'react-router-dom';
import { useAppDispatch } from '@store/hooks';
import { updateProgram } from '@store/slices/programSlice';

interface AppContextProviderProps {
  children: ReactNode;
}

/**
 * Syncs the program type from the URL path into Redux.
 * Consumers should use `useProgramConfig()` to access the current banner's configuration.
 */
export const AppContextProvider = ({ children }: AppContextProviderProps) => {
  const location = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const newProgramType = NavigationHelper.parseProgramTypeFromPath(location.pathname);
    if (newProgramType) {
      dispatch(updateProgram(newProgramType));
    }
  }, [dispatch, location.pathname]);

  return <>{children}</>;
};
